import { useEffect } from "react";
import TalaeraDefaultBackground from "components/TalaeraDefaultBackground/TalaeraDefaultBackground";
import { useRequiredContext } from "contexts/utils";
import { UserContext } from "contexts/UserContext";

/**
 * This component signs the user out when rendered.
 */
export default function SignOut() {
  const { signOut } = useRequiredContext(UserContext);

  useEffect(() => {
    void signOut();
  }, [signOut]);

  return <TalaeraDefaultBackground />;
}
